import moment from 'moment'
const production = true;
const Globals = {
  datePickerRanges: {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, 'days'), moment()],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
    'This Year': [moment().startOf('year'), moment().endOf('year')],
    'Last Year': [
      moment().subtract(1, 'year').startOf('year'),
      moment().subtract(1, 'year').endOf('year'),
    ],
  },
  APP_BASE_URL: production ? process.env.REACT_APP_LIVE_BASE_URL : process.env.REACT_APP_BASE_URL,
  APP_API_END_POINT: production ? process.env.REACT_APP_LIVE_API_END_POINT : process.env.REACT_APP_API_END_POINT,
  APP_CHAT_PORT: production ? process.env.REACT_APP_LIVE_CHAT_PORT : process.env.REACT_APP_CHAT_PORT
}
export default Globals;
